module.exports = __webpack_public_path__ + "ea16e22c1028f46034ae24feaa1c0778.svg";